// Signal emitted after any successful add/update/delete so other components
// (or the section itself) can trigger a refetch. Same pattern as the other
// v2 sections' events.js files.
export const ALG_V2_REFRESH = "alg-v2:refresh";

// Content column → editor rail: open the Add-allergy form (3071:3242).
export const ALG_V2_ADD = "alg-v2:add";

// Content column → editor rail: open the UPDATE form prefilled with an
// existing row. Payload `{ allergy }` — the record itself, so the rail can
// prefill, carry the stored category through, and title itself
// "Update · <name>". The rail owns both halves now; the old centered
// AllergyModal is no longer mounted anywhere.
export const ALG_V2_EDIT = "alg-v2:edit";

// Transcript-mode re-edit of an already-staged captured item. Payload
// `{ captured, algv2Record }` — algv2Record is null for a staged-add
// row. Mirrors CC_V2_EDIT_CAPTURED / DX_V2_EDIT_CAPTURED.
export const ALG_V2_EDIT_CAPTURED = "alg-v2:edit-captured";
